import { createReducer } from '@reduxjs/toolkit'
import { setInitial, setPage, setPages } from './actions'

const pagination = createReducer({ page: 0, pages: 1 }, {
  [setPage]: (state, action) => ({ ...state, page: action.payload }),
  [setPages]: (state, action) => ({ ...state, pages: action.payload }),
  [setInitial]: () => ({ page: 0, pages: 1 })
})

export default pagination